import standard from '@/assets/standard.js'
import * as API from '@/utils/api'
import { getHash } from '@/utils/hashid'

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    form: {
      image: null,
      modelID: 136 // 預設：桶柑模型 id
    },
    model: [], // 辨識模型: 辨識模型
    identificationResult: [], // 辨識回的資料: 辨識結果
    standard
  },
  getters: {
    effectiveRecognitionResults (state) {
      return {
        fruit: state.identificationResult.fruit?.length,
        scar: state.identificationResult.scar?.length,
        pedicle: !!state.identificationResult.pedicle?.length // 依照有蒂數量，判斷是否有蒂
      }
    },
    model (state) {
      return state.model
    },
    modelIDOfTankan (state) {
      return state.modelIDOfTankan
    },
    areaOfScar (state) {
      return state.identificationResult?.scar
        ?.filter(item => item.area)
        ?.reduce((acc, cur) => acc + cur.area, 0)
    },
    areaOfTankan (state) {
      return state.identificationResult?.fruit?.[0]?.area
    },
    proportionOfScar (state, getters) {
      if (!getters.areaOfScar || !getters.areaOfTankan) return

      const percentages = (getters.areaOfScar / getters.areaOfTankan) * 100
      return Number(percentages.toFixed(2))
    },
    // 綜合計算等級: 依照標準計算有效辨識結果得出的桶柑分級
    // 詳情等級規則請參考計算分級表
    // ! waiting for refactor
    levelComprehensive (state, getters) {
      if (!getters.proportionOfScar) return

      const scarLevel = getters.standard.filter(
        level =>
          getters.proportionOfScar >= level.scarPercent.min &&
          getters.proportionOfScar < level.scarPercent.max &&
          getters.effectiveRecognitionResults.pedicle === level.pedicle
      )

      return scarLevel[0]?.level || 'D'
    },
    standard (state) {
      return state.standard.data
    },
    standardTitle (state) {
      return state.standard.title
    },
    form (state) {
      return state.form
    }
  },
  mutations: {
    MODEL (state, playload) {
      state.model = playload
    },
    IDENTIFICATION_RESULT (state, playload) {
      state.identificationResult = playload
    },
    FORM_IMAGE (state, data) {
      state.form.image = data
    },
    FORM_MODELID (state, data) {
      state.form.modelID = data
    }
  },
  actions: {
    async getModel ({ commit }) {
      const { data: result } = await API.GET_MODEL('models', {
        params: {
          hashkey: getHash()
        }
      })
      commit('MODEL', result)
    },
    async getIdentification ({ commit, state }) {
      const formData = new FormData()
      formData.append('image', state.form.image)

      const { data: result } = await API.POST_IDENTIFICATION_RESULT(
        `model/${state.form.modelID}/detect`,
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
          params: {
            hashkey: getHash()
          }
        }
      )
      commit('IDENTIFICATION_RESULT', result)
    },
    resetIdentification ({ commit }) {
      commit('IDENTIFICATION_RESULT', [])
    }
  }
})
